import SlotRestrictionsFields from './SlotRestrictionsFields';

export default SlotRestrictionsFields;
